import * as React from "react";
import { Card, CardContent, Typography, Grid } from "@material-ui/core";
import { NumberInput, required } from "react-admin";
import { CoreInfoRequestStatusEnum } from "../../../../Enums/CoreInfoRequestStatusEnum";
import { HourMinuteInput } from "../../../../Components/HourMinuteInput";

interface TechnicalDataCardProps {
  record: any;
  classes: any;
  mode: "customer" | "tt";
  // Customer mode states
  tsi?: boolean;
  tso?: boolean;
  tsr?: boolean;
  tsn?: boolean;
  csi?: boolean;
  cso?: boolean;
  csr?: boolean;
  csn?: boolean;
  dsi?: boolean;
  dso?: boolean;
  dsr?: boolean;
  dsn?: boolean;
  validate?: any[];
}

const TechnicalDataCard: React.FC<TechnicalDataCardProps> = ({
  record,
  classes,
  mode,
  tsi,
  tso,
  tsr,
  tsn,
  csi,
  cso,
  csr,
  csn,
  dsi,
  dso,
  dsr,
  dsn,
  validate = [],
}) => {
  const isCustomerMode = mode === "customer";

  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography className={classes.cardTitle}>Technical Data</Typography>
        <Grid container spacing={2}>
          {/* Time Since Overhaul */}
          <Grid item xs={12}>
            <Typography variant="subtitle2" style={{ marginBottom: 8, color: "#666" }}>
              Time Since (Hours)
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <HourMinuteInput
                  source="tsi"
                  label="TSI"
                  hourDigits={7}
                  fullWidth
                  variant="outlined"
                  disabled={isCustomerMode ? tsi || record.status === CoreInfoRequestStatusEnum.Accepted : true}
                  validate={isCustomerMode && tsi === false ? required() : validate}
                  defaultValue={record.tsi}
                />
                <HourMinuteInput
                  source="tso"
                  label="TSO"
                  hourDigits={7}
                  fullWidth
                  variant="outlined"
                  disabled={isCustomerMode ? tso || record.status === CoreInfoRequestStatusEnum.Accepted : true}
                  validate={isCustomerMode && tso === false ? required() : validate}
                  defaultValue={record.tso}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <HourMinuteInput
                  source="tsr"
                  label="TSR"
                  hourDigits={7}
                  fullWidth
                  variant="outlined"
                  disabled={isCustomerMode ? tsr || record.status === CoreInfoRequestStatusEnum.Accepted : true}
                  validate={isCustomerMode && tsr === false ? required() : validate}
                  defaultValue={record.tsr}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <HourMinuteInput
                  source="tsn"
                  label="TSN"
                  hourDigits={7}
                  fullWidth
                  variant="outlined"
                  disabled={isCustomerMode ? tsn || record.status === CoreInfoRequestStatusEnum.Accepted : true}
                  validate={isCustomerMode && tsn === false ? required() : validate}
                  defaultValue={record.tsn}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Cycles Since */}
          <Grid item xs={12}>
            <Typography variant="subtitle2" style={{ marginBottom: 8, color: "#666" }}>
              Cycles Since
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <NumberInput
                  source="csi"
                  label="CSI"
                  fullWidth
                  variant="outlined"
                  disabled={isCustomerMode ? csi || record.status === CoreInfoRequestStatusEnum.Accepted : true}
                  validate={isCustomerMode && csi === false ? required() : validate}
                  defaultValue={record.csi}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <NumberInput
                  source="cso"
                  label="CSO"
                  fullWidth
                  variant="outlined"
                  disabled={isCustomerMode ? cso || record.status === CoreInfoRequestStatusEnum.Accepted : true}
                  validate={isCustomerMode && cso === false ? required() : validate}
                  defaultValue={record.cso}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <NumberInput
                  source="csr"
                  label="CSR"
                  fullWidth
                  variant="outlined"
                  disabled={isCustomerMode ? csr || record.status === CoreInfoRequestStatusEnum.Accepted : true}
                  validate={isCustomerMode && csr === false ? required() : validate}
                  defaultValue={record.csr}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <NumberInput
                  source="csn"
                  label="CSN"
                  fullWidth
                  variant="outlined"
                  disabled={isCustomerMode ? csn || record.status === CoreInfoRequestStatusEnum.Accepted : true}
                  validate={isCustomerMode && csn === false ? required() : validate}
                  defaultValue={record.csn}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Days Since */}
          <Grid item xs={12}>
            <Typography variant="subtitle2" style={{ marginBottom: 8, color: "#666" }}>
              Days Since
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <NumberInput
                  source="dsi"
                  label="DSI"
                  fullWidth
                  variant="outlined"
                  disabled={isCustomerMode ? dsi || record.status === CoreInfoRequestStatusEnum.Accepted : true}
                  validate={isCustomerMode && dsi === false ? required() : validate}
                  defaultValue={record.dsi}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <NumberInput
                  source="dso"
                  label="DSO"
                  fullWidth
                  variant="outlined"
                  disabled={isCustomerMode ? dso || record.status === CoreInfoRequestStatusEnum.Accepted : true}
                  validate={isCustomerMode && dso === false ? required() : validate}
                  defaultValue={record.dso}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <NumberInput
                  source="dsr"
                  label="DSR"
                  fullWidth
                  variant="outlined"
                  disabled={isCustomerMode ? dsr || record.status === CoreInfoRequestStatusEnum.Accepted : true}
                  validate={isCustomerMode && dsr === false ? required() : validate}
                  defaultValue={record.dsr}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <NumberInput
                  source="dsn"
                  label="DSN"
                  fullWidth
                  variant="outlined"
                  disabled={isCustomerMode ? dsn || record.status === CoreInfoRequestStatusEnum.Accepted : true}
                  validate={isCustomerMode && dsn === false ? required() : validate}
                  defaultValue={record.dsn}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default TechnicalDataCard;
